// src/features/owner/components/OwnerPanel.tsx — shared card chrome (title row + optional action + body).
import styled from 'styled-components';
import type { ReactNode } from 'react';

const Card = styled.section`
  background: ${({ theme }) => theme.color.glassBg};
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.lg};
  padding: 16px;
`;

const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  gap: 8px;
`;

const Title = styled.h3`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.md};
  color: ${({ theme }) => theme.color.textPrimary};
`;

export function OwnerPanel({
  title,
  action,
  children,
}: {
  title: ReactNode;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Card>
      <Head>
        <Title>{title}</Title>
        {action}
      </Head>
      {children}
    </Card>
  );
}
